import { useCallback, useMemo, useState } from "react";
import { requestAxios } from "../../config";

const useStaticRequest = (endPoint, initialValue) => {
  const [response, setResponse] = useState({
    data: initialValue,
    loading: false,
    error: null,
  });

  const uri = useMemo(() => `${endPoint}?timestamp=${new Date().getTime()}`, [
    endPoint,
  ]);

  const performRequest = useCallback(async () => {
    try {
      setResponse((prevResponse) => ({
        ...prevResponse,
        loading: true,
      }));

      const { data } = await requestAxios.get(uri);

      setResponse((prevResponse) => ({
        ...prevResponse,
        data,
        loading: false,
        error: null,
      }));

      return data;
    } catch (err) {
      setResponse((prevResponse) => ({
        ...prevResponse,
        data: null,
        loading: false,
        error: err,
      }));
    }
    return {};
  }, [uri]);

  return [response, performRequest];
};

export default useStaticRequest;
